import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import './styles/auth.css';
import CAMPUS_IMG from './assets/kampus_A.png';
import ikona from './assets/icon.png';

export default function ProwadzacyRegister() {
    const navigate = useNavigate();

    // Dostosuj jeśli masz inną ścieżkę:
    const ENDPOINT = '/api/auth/register-prowadzacy';
    // np. const ENDPOINT = '/api/uzytkownicy/zarejestruj-prowadzacy';

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName]   = useState('');
    const [email, setEmail]         = useState('');
    const [password, setPassword]   = useState('');
    const [rodoConsent, setRodoConsent] = useState(false);

    const [busy, setBusy] = useState(false);
    const [msgErr, setMsgErr] = useState('');
    const [msgOk, setMsgOk] = useState('');
    const [identyfikator, setIdentyfikator] = useState('');

    const onSubmit = async (e) => {
        e.preventDefault();
        setMsgErr('');
        setMsgOk('');
        setIdentyfikator('');
        setBusy(true);

        try {
            if (!rodoConsent) {
                setMsgErr('Aby się zarejestrować, musisz wyrazić zgodę na przetwarzanie danych osobowych.');
                return;
            }

            const res = await fetch(ENDPOINT, {
                method: 'POST',
                headers: { 'Content-Type':'application/json' },
                body: JSON.stringify({
                    first_name: firstName,
                    last_name: lastName,
                    email,
                    password
                })
            });

            const j = await res.json().catch(() => null);

            if (!res.ok) {
                throw new Error(j?.blad || 'Rejestracja nieudana');
            }

            const id = j?.identyfikator || '';
            setIdentyfikator(id);

            setMsgOk(
                id
                    ? 'Konto utworzone ✅ Możesz logować się e-mailem lub identyfikatorem poniżej.'
                    : (j?.komunikat || 'Konto utworzone ✅ Możesz się zalogować.')
            );
        } catch (err) {
            setMsgErr(err?.message || 'Błąd');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div
            className="auth-hero-bg"
            style={{ backgroundImage: `url("${CAMPUS_IMG}")` }}
            role="img"
            aria-label="Zdjęcie kampusu uczelni w tle"
        >
            <div className="auth-glass">
                {/* Nagłówek */}
                <div className="auth-head" style={{ marginBottom: 12 }}>
                    <div className="auth-badge" aria-hidden>
                        <img src={ikona} alt="Logo" style={{ height: '80px', width: '64px' }} />
                    </div>
                    <div>
                        <h1 className="auth-title">Rejestracja prowadzącego</h1>
                        <div className="auth-sub">Wypełnij dane, aby utworzyć konto prowadzącego</div>
                    </div>
                </div>

                {/* Komunikaty */}
                <div className="auth-msg" style={{ marginBottom: 10 }}>
                    {!!msgErr && <div className="auth-err">{msgErr}</div>}

                    {!!msgOk && (
                        <div className="auth-ok" style={{ backgroundColor: "rgba(10, 92, 10, 0.8)" }}>
                            <div>{msgOk}</div>

                            {!!identyfikator && (
                                <div style={{ marginTop: 10 }}>
                                    <div style={{ fontSize: 12, opacity: 1 }}>
                                        Twój identyfikator logowania:
                                    </div>
                                    <div style={{ fontWeight: 800, fontSize: 20, letterSpacing: 1 }}>
                                        {identyfikator}
                                    </div>
                                    <div style={{ marginTop: 8, fontSize: 12, opacity: 1 }}>
                                        Zapisz go — możesz logować się również tym identyfikatorem.
                                    </div>

                                    <div style={{ marginTop: 12 }}>
                                        <button className="auth-link" onClick={() => navigate('/')}>
                                            Przejdź do logowania
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {/* Układ 2-kolumny jak u studenta (po prawej info zamiast kamery) */}
                <div
                    style={{
                        gridTemplateColumns: '1fr 1fr',
                        gap: 16
                    }}
                >
                    {/* Formularz */}
                    <form onSubmit={onSubmit} style={{ gap: 16 }}>
                        <div className="auth-field">
                            <label className="auth-label" htmlFor="first">Imię</label>
                            <input
                                id="first"
                                className="auth-input"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                required
                            />
                        </div>

                        <div className="auth-field">
                            <label className="auth-label" htmlFor="last">Nazwisko</label>
                            <input
                                id="last"
                                className="auth-input"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                required
                            />
                        </div>

                        <div className="auth-field">
                            <label className="auth-label" htmlFor="email">E-mail</label>
                            <input
                                id="email"
                                type="email"
                                className="auth-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>

                        <div className="auth-field">
                            <label className="auth-label" htmlFor="pass">Hasło</label>
                            <input
                                id="pass"
                                type="password"
                                className="auth-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="minimum 8 znaków"
                                required
                            />
                        </div>

                        <div className="auth-field" style={{  marginTop: "30px"  }}>
                            <label className="auth-remember" style={{ alignItems: 'flex-start', gap: 10 }}>
                                <input
                                    type="checkbox"
                                    checked={rodoConsent}
                                    onChange={(e) => setRodoConsent(e.target.checked)}
                                    required
                                />
                                <span style={{ lineHeight: 1.4 }}>
                  Wyrażam zgodę na przetwarzanie moich danych osobowych przez Gdańską Akademię Medyczną Nauk Stosowanych
                  w celu założenia konta i obsługi procesu egzaminowania online. Zapoznałem/am się z
                  <a className="auth-link" href="/polityka-prywatnosci" target="_blank" rel="noreferrer"> polityką prywatności</a>.
                </span>
                            </label>
                        </div>

                        <button type="submit" className="auth-cta" disabled={busy}>
                            {busy ? 'Tworzę konto…' : 'Zarejestruj'}
                        </button>

                        <div className="auth-foot" style={{ marginTop: 6 }}>
                            Masz już konto?{' '}
                            <button type="button" className="auth-link" onClick={() => navigate('/')}>
                                Wróć do logowania
                            </button>
                        </div>
                    </form>

                </div>
            </div>

            {/* Stopka */}
            <div className="auth-legal">
                © {new Date().getFullYear()} Gdańska Akademia Medyczna Nauk Stosowanych
            </div>

            {/* Responsywność kolumn — jak u studenta */}
            <style>{`
        @media (max-width: 900px) {
          .auth-glass > div[style*="grid-template-columns"] {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
        </div>
    );
}